module.exports = __webpack_public_path__ + "static/img/130.eda6f25.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/130.jpg
// module id = UHO3
// module chunks = 0